import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { SUPPORTED_LANGUAGES } from "./utils/consts";
import getLanguageFromUrl from "./utils/getLanguageFromUrl";

const languageDetector = new LanguageDetector();

languageDetector.addDetector({
  name: 'urlPrefix',
  lookup: getLanguageFromUrl,
});

i18n
  // pass the i18n instance to react-i18next.
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    fallbackLng: false,
    debug: false,
    detection: {
      // Тільки URL: кука лишається кешем для LanguageSelect, але мову більше не вирішує
      order: ['urlPrefix'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: process.env.REACT_APP_LANG_VERSION }
    },
    react: {
      transSupportBasicHtmlNodes: true,
      bindI18n: 'languageChanged',
    },
  });

export default i18n;